import React, { useState } from "react";
import "./styles.css";
import "../home-category-section/styles.css";
import { IoGlobeOutline, IoInformationCircleOutline } from "react-icons/io5";
import { TranslatePopup } from "../translate-popup";

export const AdditionalInfoSection = ({ notes }) => {
  const [showTranslation, setShowTranslation] = useState(false);
  const trimmedNotes = typeof notes === "string" ? notes.trim() : "";

  if (!trimmedNotes) {
    return null;
  }

  return (
    <div className="itemContainer">
      <div className="itemHeader">
        <div className="iconContainer">
          <div
            className="iconInnerContainer"
            style={{ backgroundColor: "#D9E2FC" }}
          >
            <IoInformationCircleOutline size={26} color="#3D6FD1" />
          </div>
        </div>
        <div className="titleContainer">
          <span className="mainTitleStyling">Additional information</span>
        </div>
      </div>

      <div
        style={{
          padding: "20px",
          borderBottom: "2px solid",
          borderLeft: "2px solid",
          borderRight: "2px solid",
          borderColor: "#EFF3FC",
          borderBottomLeftRadius: 15,
          borderBottomRightRadius: 15,
        }}
      >
        <p className="additionalInfoText">{trimmedNotes}</p>
        <div
          className="buttonStyling"
          type="button"
          onClick={() => setShowTranslation(true)}
        >
          <IoGlobeOutline size={20} />
          <span>TRANSLATE</span>
        </div>
      </div>

      <TranslatePopup
        showTranslation={showTranslation}
        setShowTranslation={setShowTranslation}
        mainTitle="Additional information"
        text={trimmedNotes}
      />
    </div>
  );
};
